export const hasPermission = (permissions, permissionKey, roleType) => {
  if (roleType === 1) return true; 
  if (!permissionKey) return true; 

  const [module, action] = permissionKey.split('.');
  return permissions?.some((perm) => {
    const matchModule = perm?.title?.toLowerCase() === module?.toLowerCase();
    const isActive = perm?.status?.toLowerCase() === 'yes';
    if (!matchModule || !isActive) return false;

    return action ? perm?.permission?.[action] === 'yes' : true;
  });
};
